import { useEffect, useState, useRef } from "react";

const ScriptLoader = ({
	src,
	content,
	id,
	async = false,
	defer = false,
	onLoad,
	onError,
	attributes = {},
}) => {
	const [status, setStatus] = useState("idle");
	const scriptRef = useRef(null);

	useEffect(() => {
		if (!src && !content) return;

		if (status === "ready") return;

		const script = document.createElement("script");
		scriptRef.current = script;

		// Ustawienie atrybutów
		if (id) script.id = id;
		if (src) script.src = src;
		if (async) script.async = true;
		if (defer) script.defer = true;

		// Dodanie niestandardowych atrybutów
		Object.entries(attributes).forEach(([key, value]) => {
			script.setAttribute(key, value);
		});

		// Obsługa zdarzeń
		const handleLoad = () => {
			setStatus("ready");
			if (onLoad) onLoad();
		};

		const handleError = (error) => {
			setStatus("error");
			if (onError) onError(error);
		};

		script.addEventListener("load", handleLoad);
		script.addEventListener("error", handleError);

		// Dodanie treści inline jeśli istnieje
		if (content) {
			script.textContent = content;
		}

		// Dodanie skryptu do dokumentu
		document.body.appendChild(script);

		return () => {
			script.removeEventListener("load", handleLoad);
			script.removeEventListener("error", handleError);

			document.body.removeChild(script);
		};
	}, [src, content, id, async, defer, onLoad, onError, status]);

	return null;
};

export default ScriptLoader;
